const initialState = [
  'MR_DISTRIBUTION_FIRST_SHIPMENT',
  'MR_DISTRIBUTION_SECOND_SHIPMENT',
];
const initialStateForTest = [
  'MR_DISTRIBUTION_FIRST_SHIPMENT',
  'MR_DISTRIBUTION_SECOND_SHIPMENT',
];

export default initialState;
export { initialStateForTest };
